export default __webpack_public_path__ + "static/media/wint.bfd4cf93.png";